<script>
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import RangeSlider from '@/components/pc/radio/ipradio/atoms/RangeSlider.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  name: 'ToneAudioAudioVolume',
  components: {
    RadioGroup,
    RangeSlider,
    SelectBox,
    ToggleSwitch,
    SettingGroup,
    SettingItem,
  },
  data() {
    const radioSettings = useRadioSettingsStore()

    const radioBtnOptions = {
      rxAutoGainControl: Object.keys(
        BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.RX_AUDIO_RESPONSE.AUTO_GAIN_CONTROL,
      )
        .filter((key) => key !== 'DISABLE')
        .map((key) => ({
          label:
            BC_TRANS_JP.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.RX_AUDIO_RESPONSE
              .AUTO_GAIN_CONTROL[key],
          value:
            BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.RX_AUDIO_RESPONSE.AUTO_GAIN_CONTROL[key],
        })),
    }

    const selectboxOptions = {
      tone: BC.COMMON.TONE.SELECT.map((v) => ({ label: v, value: v })),
    }

    return {
      radioSettings,
      setting: radioSettings.getTempSetting(),
      radioBtnOptions,
      selectboxOptions,

      form: {
        radioBtn: {
          rxAutoGainControl: radioBtnOptions.rxAutoGainControl[0].value,
        },
        selectbox: {
          powerOnTone: selectboxOptions.tone[0].value,
          controlTone: selectboxOptions.tone[0].value,
          warningTone: selectboxOptions.tone[0].value,
          alertTone: selectboxOptions.tone[0].value,
          sideTone: selectboxOptions.tone[0].value,
          locatorTone: selectboxOptions.tone[0].value,
        },
        toggle: {
          powerOnTone: false,
          controlTone: false,
          warningTone: false,
          alertTone: false,
          sideTone: false,
          locatorTone: false,
          pttReleaseTone: false,
          pttProceedTone: false,
          playbackEndTone: false,
          group: false,
          function: false,
          echoModeFunction: false,
          rxAutoGainControl: false,
          txAutoGainControl: false,
          vibratorFunction: false,
          withoutAlertTone: false,
          echoCanceller: false,
        },
        range: {
          volumeOffsetValue: 0,
          powerOnToneValue: 0,
          controlToneValue: 0,
          warningToneValue: 0,
          alertToneValue: 0,
          sideToneValue: 0,
          locatorToneValue: 0,
          echoModeVolume: 0,
          maximum: 0,
          minimum: 0,
        },
      },
    }
  },
  computed: {
    BC() {
      return BC
    },
    BC_TRANS_JP() {
      return BC_TRANS_JP
    },
  },
  watch: {
    // 保存・反映
    form: {
      deep: true,
      handler() {
        this.transForm2Setting()
        this.radioSettings.saveTempSetting(this.setting)
      },
    },
  },
  methods: {
    handleVibratorSwitch(value){
      if(!value){
        this.form.toggle.withoutAlertTone = false;
      }
    },
    syncAudioVolumeRange(changedKey) {
      if (this.form.range.maximum >= this.form.range.minimum) {
        return
      }

      if (changedKey === 'maximum') {
        this.form.range.minimum = this.form.range.maximum
        return
      }

      this.form.range.maximum = this.form.range.minimum
    },
    updateAudioVolumeMaximum(value) {
      this.form.range.maximum = value
      this.syncAudioVolumeRange('maximum')
    },
    updateAudioVolumeMinimum(value) {
      this.form.range.minimum = value
      this.syncAudioVolumeRange('minimum')
    },
    volumeLevelForm2Setting(toggle, selectbox) {
      if (!toggle) return BC.COMMON.TONE.DISABLE
      if (selectbox === BC_TRANS_JP.COMMON.TONE.FIXED) return BC.COMMON.TONE.FIXED
      if (selectbox === BC_TRANS_JP.COMMON.TONE.CURRENT) return BC.COMMON.TONE.CURRENT
      if (selectbox === BC_TRANS_JP.COMMON.TONE.SELECTABLE) return BC.COMMON.TONE.SELECTABLE
      return BC.COMMON.TONE.DISABLE
    },
    volumeLevelSetting2Form(value) {
      if (value === BC.COMMON.TONE.FIXED) return BC_TRANS_JP.COMMON.TONE.FIXED
      if (value === BC.COMMON.TONE.CURRENT) return BC_TRANS_JP.COMMON.TONE.CURRENT
      if (value === BC.COMMON.TONE.SELECTABLE) return BC_TRANS_JP.COMMON.TONE.SELECTABLE
      // DISABLE の場合は CURRENT を初期値
      return BC_TRANS_JP.COMMON.TONE.CURRENT
    },
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.Tone_Audio_AudioVolume

      data.VolumeLevel.ToneVolumeOffset = this.form.range.volumeOffsetValue
      data.VolumeLevel['Power-onTone'] = this.volumeLevelForm2Setting(
        this.form.toggle.powerOnTone,
        this.form.selectbox.powerOnTone,
      )
      data.VolumeLevel['Power-onToneValue'] = this.form.range.powerOnToneValue

      data.VolumeLevel.ControlTone = this.volumeLevelForm2Setting(
        this.form.toggle.controlTone,
        this.form.selectbox.controlTone,
      )
      data.VolumeLevel.ControlToneValue = this.form.range.controlToneValue

      data.VolumeLevel.WarningTone = this.volumeLevelForm2Setting(
        this.form.toggle.warningTone,
        this.form.selectbox.warningTone,
      )
      data.VolumeLevel.WarningToneValue = this.form.range.warningToneValue

      data.VolumeLevel.AlertTone = this.volumeLevelForm2Setting(
        this.form.toggle.alertTone,
        this.form.selectbox.alertTone,
      )
      data.VolumeLevel.AlertToneValue = this.form.range.alertToneValue

      data.VolumeLevel.SideTone = this.volumeLevelForm2Setting(
        this.form.toggle.sideTone,
        this.form.selectbox.sideTone,
      )
      data.VolumeLevel.SideToneValue = this.form.range.sideToneValue

      data.VolumeLevel.LocatorTone = this.volumeLevelForm2Setting(
        this.form.toggle.locatorTone,
        this.form.selectbox.locatorTone,
      )
      data.VolumeLevel.LocatorToneValue = this.form.range.locatorToneValue

      data.ProceedTone.PTTReleaseTone = this.form.toggle.pttReleaseTone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.ProceedTone.PTTProceedTone = this.form.toggle.pttProceedTone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.Recording.PlaybackEndTone = this.form.toggle.playbackEndTone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.VoiceAnnouncement.Group = this.form.toggle.group
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.VoiceAnnouncement.Function = this.form.toggle.function
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.EchoMode.EchoModeFunction = this.form.toggle.echoModeFunction
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.EchoMode.EchoModeVolume = this.form.range.echoModeVolume

      data.AudioVolume.Maximum = this.form.range.maximum
      data.AudioVolume.Minimum = this.form.range.minimum

      data.RxAudioResponse.AutoGainControl = this.form.toggle.rxAutoGainControl
        ? this.form.radioBtn.rxAutoGainControl
        : BC.COMMON.TOGGLE.DISABLE

      data.TxAudioResponse.AutoGainControl = this.form.toggle.txAutoGainControl
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.Vibrator.VibratorFunction = this.form.toggle.vibratorFunction
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.Vibrator.WithoutAlertTone = this.form.toggle.withoutAlertTone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.EchoCanceller.EchoCancellerFunction = this.form.toggle.echoCanceller
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
    },
    transSetting2Form() {
      const data = this.setting.OptionalFeatures.Tone_Audio_AudioVolume

      this.form.range.volumeOffsetValue = data.VolumeLevel.ToneVolumeOffset

      this.form.toggle.powerOnTone = data.VolumeLevel['Power-onTone'] !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.powerOnTone = this.volumeLevelSetting2Form(
        data.VolumeLevel['Power-onTone'],
      )
      this.form.range.powerOnToneValue = data.VolumeLevel['Power-onToneValue']

      this.form.toggle.controlTone = data.VolumeLevel.ControlTone !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.controlTone = this.volumeLevelSetting2Form(data.VolumeLevel.ControlTone)
      this.form.range.controlToneValue = data.VolumeLevel.ControlToneValue

      this.form.toggle.warningTone = data.VolumeLevel.WarningTone !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.warningTone = this.volumeLevelSetting2Form(data.VolumeLevel.WarningTone)
      this.form.range.warningToneValue = data.VolumeLevel.WarningToneValue

      this.form.toggle.alertTone = data.VolumeLevel.AlertTone !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.alertTone = this.volumeLevelSetting2Form(data.VolumeLevel.AlertTone)
      this.form.range.alertToneValue = data.VolumeLevel.AlertToneValue

      this.form.toggle.sideTone = data.VolumeLevel.SideTone !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.sideTone = this.volumeLevelSetting2Form(data.VolumeLevel.SideTone)
      this.form.range.sideToneValue = data.VolumeLevel.SideToneValue

      this.form.toggle.locatorTone = data.VolumeLevel.LocatorTone !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.locatorTone = this.volumeLevelSetting2Form(data.VolumeLevel.LocatorTone)
      this.form.range.locatorToneValue = data.VolumeLevel.LocatorToneValue

      this.form.toggle.pttReleaseTone =
        data.ProceedTone.PTTReleaseTone === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.pttProceedTone =
        data.ProceedTone.PTTProceedTone === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.playbackEndTone =
        data.Recording.PlaybackEndTone === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.group = data.VoiceAnnouncement.Group === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.function = data.VoiceAnnouncement.Function === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.echoModeFunction =
        data.EchoMode.EchoModeFunction === BC.COMMON.TOGGLE.ENABLE
      this.form.range.echoModeVolume = data.EchoMode.EchoModeVolume

      this.form.range.maximum = data.AudioVolume.Maximum
      this.form.range.minimum = data.AudioVolume.Minimum

      this.form.toggle.rxAutoGainControl =
        data.RxAudioResponse.AutoGainControl !== BC.COMMON.TOGGLE.DISABLE
      this.form.radioBtn.rxAutoGainControl =
        data.RxAudioResponse.AutoGainControl !== BC.COMMON.TOGGLE.DISABLE
          ? data.RxAudioResponse.AutoGainControl
          : BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.RX_AUDIO_RESPONSE.AUTO_GAIN_CONTROL.LOW

      this.form.toggle.txAutoGainControl =
        data.TxAudioResponse.AutoGainControl === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.vibratorFunction =
        data.Vibrator.VibratorFunction === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.withoutAlertTone =
        data.Vibrator.WithoutAlertTone === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.echoCanceller =
        data.EchoCanceller.EchoCancellerFunction === BC.COMMON.TOGGLE.ENABLE
    },
    handleSelectBox(key, value) {
      this.form.selectbox[key] = value
    },
  },
  created() {
    this.transSetting2Form()
  },
}
</script>

<template>
  <div>
    <SettingGroup title="トーン音量">
      <SettingItem label="トーン音量オフセット値">
        <RangeSlider
          :inputValue="form.range.volumeOffsetValue"
          @update:inputValue="form.range.volumeOffsetValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME_OFFSET.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME_OFFSET.MAX"
        />
      </SettingItem>
      <SettingItem label="電源オン時のトーン">
        <ToggleSwitch v-model="form.toggle.powerOnTone" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.powerOnTone"
          :options="selectboxOptions.tone"
          :defaultValue="String(form.selectbox.powerOnTone)"
          @update="(value) => handleSelectBox('powerOnTone', value)"
        />
      </SettingItem>
      <SettingItem
        label=""
        v-if="
          form.selectbox.powerOnTone === BC_TRANS_JP.COMMON.TONE.FIXED && form.toggle.powerOnTone
        "
      >
        <RangeSlider
          :inputValue="form.range.powerOnToneValue"
          @update:inputValue="form.range.powerOnToneValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MAX"
          :disable="
            form.selectbox.powerOnTone !== BC_TRANS_JP.COMMON.TONE.FIXED || !form.toggle.powerOnTone
          "
        />
      </SettingItem>
      <SettingItem label="制御トーン">
        <ToggleSwitch v-model="form.toggle.controlTone" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.controlTone"
          :options="selectboxOptions.tone"
          :defaultValue="String(form.selectbox.controlTone)"
          @update="(value) => handleSelectBox('controlTone', value)"
        />
      </SettingItem>
      <SettingItem
        label=""
        v-if="
          form.selectbox.controlTone === BC_TRANS_JP.COMMON.TONE.FIXED && form.toggle.controlTone
        "
      >
        <RangeSlider
          :inputValue="form.range.controlToneValue"
          @update:inputValue="form.range.controlToneValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MAX"
          :disable="
            form.selectbox.controlTone !== BC_TRANS_JP.COMMON.TONE.FIXED || !form.toggle.controlTone
          "
        />
      </SettingItem>
      <SettingItem label="警告トーン">
        <ToggleSwitch v-model="form.toggle.warningTone" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.warningTone"
          :options="selectboxOptions.tone"
          :defaultValue="String(form.selectbox.warningTone)"
          @update="(value) => handleSelectBox('warningTone', value)"
        />
      </SettingItem>
      <SettingItem
        label=""
        v-if="
          form.selectbox.warningTone === BC_TRANS_JP.COMMON.TONE.FIXED && form.toggle.warningTone
        "
      >
        <RangeSlider
          :inputValue="form.range.warningToneValue"
          @update:inputValue="form.range.warningToneValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MAX"
          :disable="
            form.selectbox.warningTone !== BC_TRANS_JP.COMMON.TONE.FIXED || !form.toggle.warningTone
          "
        />
      </SettingItem>
      <SettingItem label="着信トーン">
        <ToggleSwitch v-model="form.toggle.alertTone" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.alertTone"
          :options="selectboxOptions.tone"
          :defaultValue="String(form.selectbox.alertTone)"
          @update="(value) => handleSelectBox('alertTone', value)"
        />
      </SettingItem>
      <SettingItem
        label=""
        v-if="form.selectbox.alertTone === BC_TRANS_JP.COMMON.TONE.FIXED && form.toggle.alertTone"
      >
        <RangeSlider
          :inputValue="form.range.alertToneValue"
          @update:inputValue="form.range.alertToneValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MAX"
          :disable="
            form.selectbox.alertTone !== BC_TRANS_JP.COMMON.TONE.FIXED || !form.toggle.alertTone
          "
        />
      </SettingItem>
      <SettingItem label="サイドトーン">
        <ToggleSwitch v-model="form.toggle.sideTone" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.sideTone"
          :options="selectboxOptions.tone"
          :defaultValue="String(form.selectbox.sideTone)"
          @update="(value) => handleSelectBox('sideTone', value)"
        />
      </SettingItem>
      <SettingItem
        label=""
        v-if="form.selectbox.sideTone === BC_TRANS_JP.COMMON.TONE.FIXED && form.toggle.sideTone"
      >
        <RangeSlider
          :inputValue="form.range.sideToneValue"
          @update:inputValue="form.range.sideToneValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MAX"
          :disable="
            form.selectbox.sideTone !== BC_TRANS_JP.COMMON.TONE.FIXED || !form.toggle.sideTone
          "
        />
      </SettingItem>
      <SettingItem label="エマージェンシー・トーン">
        <ToggleSwitch v-model="form.toggle.locatorTone" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.locatorTone"
          :options="selectboxOptions.tone"
          :defaultValue="String(form.selectbox.locatorTone)"
          @update="(value) => handleSelectBox('locatorTone', value)"
        />
      </SettingItem>
      <SettingItem
        label=""
        v-if="
          form.selectbox.locatorTone === BC_TRANS_JP.COMMON.TONE.FIXED && form.toggle.locatorTone
        "
      >
        <RangeSlider
          :inputValue="form.range.locatorToneValue"
          @update:inputValue="form.range.locatorToneValue = $event"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.VOLUME_LEVEL.TONE_VOLUME.MAX"
          :disable="
            form.selectbox.locatorTone !== BC_TRANS_JP.COMMON.TONE.FIXED || !form.toggle.locatorTone
          "
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="通話トーン">
      <SettingItem label="終話トーン">
        <ToggleSwitch v-model="form.toggle.pttReleaseTone" :disable="false" />
      </SettingItem>
      <SettingItem label="通話開始トーン">
        <ToggleSwitch v-model="form.toggle.pttProceedTone" :disable="false" />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="録音">
      <SettingItem label="再生終了トーン">
        <ToggleSwitch v-model="form.toggle.playbackEndTone" :disable="false" />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="音声アナウンス">
      <SettingItem label="グループ">
        <ToggleSwitch v-model="form.toggle.group" :disable="false" />
      </SettingItem>
      <SettingItem label="機能">
        <ToggleSwitch v-model="form.toggle.function" :disable="false" />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="エコーモード">
      <SettingItem label="エコーモード">
        <ToggleSwitch v-model="form.toggle.echoModeFunction" :disable="false" />
      </SettingItem>
      <SettingItem label="エコーモード音量調整">
        <RangeSlider
          :inputValue="form.range.echoModeVolume"
          @update:inputValue="form.range.echoModeVolume = $event"
          :disable="!form.toggle.echoModeFunction"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.ECHO_MODE.ECHO_MODE_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.ECHO_MODE.ECHO_MODE_VOLUME.MAX"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="オーディオ音量">
      <SettingItem label="最大音量">
        <RangeSlider
          :inputValue="form.range.maximum"
          @update:inputValue="updateAudioVolumeMaximum($event)"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.AUDIO_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.AUDIO_VOLUME.MAX"
        />
      </SettingItem>
      <SettingItem label="最小音量">
        <RangeSlider
          :inputValue="form.range.minimum"
          @update:inputValue="updateAudioVolumeMinimum($event)"
          :minLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.AUDIO_VOLUME.MIN"
          :maxLimit="BC.OPTIONAL_FEATURES.TONE_AUDIO_AUDIO_VOLUME.AUDIO_VOLUME.MAX"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="バイブレーター">
      <SettingItem label="バイブレーター">
        <ToggleSwitch v-model="form.toggle.vibratorFunction" @change="(value) => handleVibratorSwitch(value)" :disable="false" />
      </SettingItem>
      <SettingItem label="着信トーンなし">
        <ToggleSwitch v-model="form.toggle.withoutAlertTone" :disable="!form.toggle.vibratorFunction" />
      </SettingItem>
    </SettingGroup>
    <SettingGroup title="エコーキャンセラ">
      <SettingItem label="エコーキャンセラ">
        <ToggleSwitch v-model="form.toggle.echoCanceller" :disable="false" />
      </SettingItem>
    </SettingGroup>
  </div>
</template>
